import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { updateBlogCategory, getBlogCategoryById } from "adminApi/BlogApi/BlogCategory";
import { BlogCategoryRules } from "validation/ValidationRules";
import { validateForm } from "utils/validation";
import Spinner from "Common/Globle/Spinner";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import fields from "../../json/BlogCategoryFields.json";
import BlogCategoryForm from "../AddBlogCategory/Components/BlogCategoryForm";

const EditBlogCategory = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(initialValues, BlogCategoryRules);

    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getBlogCategoryById, setValues);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => await updateBlogCategory({ id, data: formValues }),
        (vals) => {
            const err = validateForm(vals, BlogCategoryRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Category updated successfully"
    );

    return (
        <>
            {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
            <BlogCategoryForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit Blog Category"
                submitLabel="Update Category"
            />
        </>
    );
};

export default EditBlogCategory;
